module.exports = __webpack_public_path__ + "img/ed_sheeran.9121c1b0.jpg";